import React from "react";
import styled from "styled-components";

const SwitchContainer = styled.div`
  display: flex;
  position: relative;
  width: 260px;
  height: 40px;
  padding: 4px;
  align-items: center;
  border-radius: 100px;
  border: 1px solid var(--Colors-Neutral-300, #e9ecef);
  background: var(--Colors-Neutral-200, #f8f9fa);

  &:focus {
    outline: 2px solid #00c0f0; /* Customize this color as needed */
  }
`;

const SwitchButton = styled.button`
  flex: 1;
  height: 100%;
  background: transparent;
  border: none;
  padding: 8px 16px;
  gap: 10px;
  color: ${({ isActive }) => (isActive ? "#161718" : "#6C757D")};
  font-size: 20px;
  font-weight: ${({ isActive }) => (isActive ? "600" : "400")};
  line-height: 24px;
  cursor: pointer;
  position: relative;
  z-index: 2;
  outline: none;

  &:focus {
    border-radius: 100px;
    outline: 2px solid #00c0f0; /* Customize this color as needed */
  }
`;

const ActiveIndicator = styled.div`
  position: absolute;
  top: 2px;
  left: ${({ isActive }) => (isActive ? "2px" : "calc(50% + 1px)")};
  width: calc(50% - 2px);
  height: calc(100% - 4px);
  border-radius: 100px;
  background: var(--Colors-Secondary-300, #89dee4);
  transition: all 0.3s ease;
  z-index: 1;
`;

const ToggleSwitch = ({ activeTab, setActiveTab }) => {
  return (
    <SwitchContainer tabIndex="0">
      <SwitchButton
        isActive={activeTab === "sections"}
        onClick={() => setActiveTab("sections")}
      >
        Sections
      </SwitchButton>
      <SwitchButton
        isActive={activeTab === "items"}
        onClick={() => setActiveTab("items")}
      >
        Items
      </SwitchButton>
      <ActiveIndicator isActive={activeTab === "sections"} />
    </SwitchContainer>
  );
};

export default ToggleSwitch;
